exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-container .form-element-design-action-container+.fts-form-group>.fts-form-label:hover,.fts-form-container .form-element-design-action-container:hover+.fts-form-group>.fts-form-label{background-color:rgba(var(--fts-gray-400-rgb),.085)}", ""]);

// exports
